<template>
  <div id="app">
    <notifications classes="custom-notification" />
    <!-- FIXME: 
      remover depois esse component de noficação abaixo, apenas o de cima é necessário, porém mantive esse abaixo pra evitar
      alterar muitos arquivos que chamam o notify com o atributo group: "notifications-default -->
    <notifications group="notifications-default" classes="custom-notification" />
    <router-view />
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-notification/vue-notification.scss" lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
let APP_TITLE = process.env.VUE_APP_TITLE || 'Atena';

export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: `%s - ${APP_TITLE}`
  },
  updated() {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1);
  },
  mounted() {
    const theme = this.$util.getTheme();
    if (theme) {
      this.$util.setTheme(theme);
    }
  }
};
</script>
